import { autoinject } from "aurelia-framework";
import { ValidationControllerFactory, ValidationController, ValidationRules } from "aurelia-validation";
import { CustomValidationRenderer } from "../../../../../../client-validation-system/custom-validation-renderer";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
export class DeleteCustomReportDialog {

    validator: ValidationController;

    constructor(private dialogClientService: DialogClientService, private validationControllerFactory: ValidationControllerFactory) {
        this.validator = this.validationControllerFactory.createForCurrentScope();
        this.validator.addRenderer(new CustomValidationRenderer());
    }

    public reason: string;
    public items: any[] = [];
    public names: string;

    private deleteFunc: (items: any[], reason: string) => any;

    activate(model: { items: any[], deleteFunc: (items: any[], reason: string) => void }) {
        this.items = model.items;
        this.names = this.items.map(c => c.name).join(", ");
        this.deleteFunc = model.deleteFunc;
        this.addValidations();
    }

    private addValidations() {
        ValidationRules
            .ensure<DeleteCustomReportDialog, string>(x => x.reason)
            .required()
            .withMessage("Reason for deletion is required")
            .on(this);

        this.validator.addObject(this);
    }

    close() {
        this.dialogClientService.hide();
    }

    onConfirm(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.validator.validate().then(v => {
                if (v.valid) {
                    this.deleteFunc(this.items, this.reason).then(() => {
                        resolve();
                        this.dialogClientService.hide();
                    }).catch(() => {
                        reject();
                    });
                }
                else reject();
            }).catch(() => {
                reject();
            });
        });
    }

}